'use client'

import { type FC } from 'react'

import {
  FEATURE_TOGGLE_BONUS_LP_NEW_DESIGN,
  useFeatureToggleContext,
} from '../../feature-toggles'
import { ErxBonusLp } from '../versions/default/ErxBonusLp'
import { ErxBonusLpV1 } from '../versions/v1/ErxBonusLpV1'

import { ErxBonusLandingPageSeoHeadTags } from './ErxBonusLandingPageSeoHeadTags'

export const ErxBonusLandingPage: FC = () => {
  const featureToggles = useFeatureToggleContext()
  const useErxBonusLpNewDesign =
    featureToggles[FEATURE_TOGGLE_BONUS_LP_NEW_DESIGN]

  return (
    <>
      <ErxBonusLandingPageSeoHeadTags />
      {useErxBonusLpNewDesign ? <ErxBonusLpV1 /> : <ErxBonusLp />}
    </>
  )
}
